(function () {
    'use strict';
    angular.module('servicesModule')
        .controller('AboutDocumentModalController', controller);

    controller.$inject = ['$scope', '$http', '$uibModal', '$uibModalInstance', 'model', '$sce'];

    function controller($scope, $http, $uibModal, $modalInstance, model, $sce) {
        var vm = this;
        vm.globalResources = angular.copy(globalResources);
        vm.data = model;
        vm.close = close;
        vm.goToFolder = goToFolder;

        initialize();

        function initialize() {
            handleScroll();
        }

        function handleScroll() {
            setTimeout(function () {
                angular.element(document.querySelector('.about-detail-container')).bind('scroll', function () {
                    const aboutDetailContainerTop = $('#documentViewId').position().top;
                    const documentTitleContainerBottom = $('#documentTitleContainer').position().top + $('#documentTitleContainer').height();
                    if (aboutDetailContainerTop < documentTitleContainerBottom) {
                        angular.element('#documentTitleContainer').addClass('shadow-effect');
                    }
                    else {
                        angular.element('#documentTitleContainer').removeClass('shadow-effect');
                    }
                })
            }, 0)
        }
     
        function close() {
            $modalInstance.close(true);
        };

        function goToFolder(folderId) {
            vm.close();
            window.open(`/folder/${folderId}`, '_self')
        }
    };
})();